import { ArrowLeft, Dot } from 'lucide-react';
import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  CardTitle,
  Dialog,
  DialogContent,
  DialogTitle,
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
  cn,
} from '@virtual-care/shadcn';

import { sendOtp } from '../firebase.tsx';
import { ResendButton } from './resend-button.tsx';

export function PhoneVerificationDialog(props: {
  children: ReactNode;
  phoneNumber: string;
}) {
  const { t } = useTranslation();
  return (
    <Dialog>
      <DialogContent className="sm:max-w-[425px]">
        <DialogTitle className={cn('space-y-4', 'text-center')}>
          <div className="space-y-2">
            <CardTitle className="font-normal">
              {t('auth.verifyPhone.title')}
            </CardTitle>
            <p className="text-muted-foreground text-sm">
              {t('auth.verifyPhone.subtitle')}
            </p>
          </div>
        </DialogTitle>

        <div className="flex justify-center" dir="ltr">
          <InputOTP maxLength={6}>
            <InputOTPGroup>
              <InputOTPSlot index={0} />
              <InputOTPSlot index={1} />
              <InputOTPSlot index={2} />
            </InputOTPGroup>
            <div role="separator">
              <Dot />
            </div>
            <InputOTPGroup>
              <InputOTPSlot index={3} />
              <InputOTPSlot index={4} />
              <InputOTPSlot index={5} />
            </InputOTPGroup>
          </InputOTP>
        </div>

        <div className="flex items-center justify-center gap-x-1">
          <p className="text-muted-foreground text-sm">
            {t('auth.verifyPhone.didntReceive')}
          </p>
          <ResendButton
            onResend={() => {
              void sendOtp(props.phoneNumber);
            }}
          />
        </div>

        <Button type="submit" className="w-full cursor-pointer">
          {t('auth.signup.submit')}
          <ArrowLeft className="mx-2 h-4 w-4 rtl:rotate-180" />
        </Button>
      </DialogContent>
      {props.children}
    </Dialog>
  );
}
